<div id="footer">
  <div id="footer-top">
    <div class="container" fxLayout="row wrap" fxLayoutAlign="space-around center">
      <ng-container *ngFor="let link of links">
        <a *ngIf="!link?.target" routerLink="{{ link.url }}" title="{{ link.title }}">{{
          link.text }}</a>
        <a *ngIf="link?.target" routerLink="{{ link.url }}" title="{{ link.title }}" target="{{link.target}}">{{
          link.text }}</a>
      </ng-container>
    </div>
  </div>
  <div id="footer-bottom">
    <div class="container" fxLayout="row" fxLayoutAlign="space-between center">
      <img src="../assets/images/footer-logo.png" alt="United HealthCare Logo" />
      <span>
        Copyright &copy; {{ date | date: "yyyy" }} United HealthCare Services,
        Inc.
      </span>
    </div>
  </div>
</div>
